"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agra": {
    "dcb1a556": [{
      "hkey": "948e18f0",
      "slug": "agra",
      "name": "Agra",
      "primary": true,
      "skipSearch": false
    }],
    "bedore": [{
      "hkey": "948e18f0",
      "slug": "agra",
      "name": "Agra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "567d8ca9": [{
      "hkey": "948e18f0",
      "slug": "agra",
      "name": "Agra",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-della-lupera": [{
      "hkey": "948e18f0",
      "slug": "agra",
      "name": "Agra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;